import { ReactNode } from "react"

interface ShadowBoxProps {
    children: ReactNode
    className?: string
    // Wizard loan mobile : la carte disparaît (bordure/ombre/arrondi seulement à partir de md)
    flatOnMobile?: boolean
    "data-testid"?: string
}

export default function ShadowBox({
    children,
    className = "",
    flatOnMobile = false,
    "data-testid": dataTestId,
}: ShadowBoxProps) {
    const boxClasses = flatOnMobile
        ? "md:border md:border-rm-gray-light md:rounded-2xl md:shadow-[0px_4px_3px_rgba(0,0,0,0.1),0px_2px_2px_rgba(0,0,0,0.1)]"
        : "border border-rm-gray-light rounded-2xl shadow-[0px_4px_3px_rgba(0,0,0,0.1),0px_2px_2px_rgba(0,0,0,0.1)]"
    return (
        <div className={`bg-white ${boxClasses} ${className}`} data-testid={dataTestId}>
            {children}
        </div>
    )
}
